import type { TourPage } from './types';

const registry = new Map<string, TourPage>();

export function registerTourPage(routeName: string, page: TourPage): void {
  registry.set(routeName, page);
}

export function getTourPage(routeName: string | null | undefined): TourPage | null {
  if (!routeName) return null;
  return registry.get(routeName) ?? null;
}

export function hasTourFor(routeName: string | null | undefined): boolean {
  return !!getTourPage(routeName);
}

export function listRegisteredRoutes(): string[] {
  return Array.from(registry.keys());
}
